import React from 'react';
import * as classNames from 'classnames';
var selfStyles = require('./styles.scss');
var ListAthletesItemAthleteScoreRouteItem = function (props) {
    var athleteScoreRoute = typeof props.athleteScoreRoute.calculated === 'string'
        ? JSON.parse(props.athleteScoreRoute.calculated)
        : props.athleteScoreRoute.calculated;
    var overflowStyle = props.width > 50
        ? { minWidth: props.width }
        : {};
    return (React.createElement("div", { style: overflowStyle, className: classNames(selfStyles.athleteScoreRouteItem, (_a = {}, _a[selfStyles.athleteScoreRouteItemHover] = !!props.isPlatform, _a)), onClick: props.onClick }, athleteScoreRoute.display));
    var _a;
};
export default ListAthletesItemAthleteScoreRouteItem;



//////////////////
// WEBPACK FOOTER
// ./src/imports/components/Scoreboard/components/ListAthletesItemAthleteScoreRouteItem.tsx
// module id = 710
// module chunks = 0